<template>
  <div class="container p-0" :key="customKey">
    <div class="content p-0">
      <div class="details ml-0">
        <textarea
          class="title"
          type="text"
          id="task-title-input"
          :placeholder="newTitle === '' ? 'Tytuł zadania' : ''"
          v-model="newTitle"
          :class="
            fieldsErrors && fieldsErrors.includes('newTitle')
              ? 'error-content'
              : ''
          "
        />
        <div class="p-0">
          <p class="label">Kategoria:</p>
          <custom-select
            default-value=""
            :options="
              ((tasksCategories && tasksCategories.data) || []).map((e) => ({
                value: e.id,
                name: e.name,
                shortName: e.name,
              }))
            "
            :graySelect="true"
            :large="true"
            :markSelected="true"
            :prePick="newCategoryId"
            style="width: 320px"
            @newPick="(e) => (newCategoryId = e)"
            :class="
              fieldsErrors && fieldsErrors.includes('newCategoryId')
                ? 'error-content'
                : ''
            "
          />
        </div>
        <div class="p-0">
          <p class="label">Priorytet:</p>
          <custom-select
            default-value=""
            :options="
              ((tasksPriorities && tasksPriorities.data) || []).map((e) => ({
                value: e.id,
                name: e.name,
                shortName: e.name,
              }))
            "
            :graySelect="true"
            :large="true"
            :markSelected="true"
            :prePick="newPriorityId"
            style="width: 320px"
            @newPick="(e) => (newPriorityId = e)"
            :class="
              fieldsErrors && fieldsErrors.includes('newPriorityId')
                ? 'error-content'
                : ''
            "
          />
        </div>
        <div class="p-0">
          <p class="label">Osoba, której dotyczy zadanie:</p>
          <custom-select
            :default-value="
              (!customerUser || (customerUser && !customerUser.id)) &&
              (!employeeUser || (employeeUser && !employeeUser.id))
                ? 'Imię i nazwisko'
                : customerUser
                ? `${customerUser.firstName} ${customerUser.lastName} - Podopieczny`
                : `${employeeUser.firstName} ${employeeUser.lastName} - Opiekun`
            "
            :options="
              ((usersList && usersList.data) || []).map((e) => ({
                ...e,
                value: e.id,
                name: `${e.firstName} ${e.lastName || ''} ${
                  e.role === 'CUSTOMER' ? ' - Podopieczny' : ' - Opiekun'
                }`,
                shortName: `${e.firstName} ${e.lastName || ''} ${
                  e.role === 'CUSTOMER' ? ' - Podopieczny' : ' - Opiekun'
                }`,
              }))
            "
            :graySelect="true"
            :isAutocomplete="true"
            :large="true"
            :markSelected="true"
            style="width: 320px"
            :smallOptions="true"
            :emitWholeObject="true"
            :prePick="
              employee && employee.id
                ? employee.id
                : customer && customer.id
                ? customer.id
                : ''
            "
            @newPick="
              (e) =>
                e.numberOfScheduledHours !== null
                  ? handleNewPersonPick(e)
                  : handleNewPersonPick(e)
            "
            :class="
              fieldsErrors && fieldsErrors.includes('person')
                ? 'error-content'
                : ''
            "
          />
        </div>
        <div class="p-0">
          <p
            v-if="(customer && customer.phone) || (employee && employee.phone)"
            class="label"
          >
            {{
              customer !== undefined && customer.phone
                ? customer.phone
                : employee !== undefined && employee.phone
                ? employee.phone
                : ""
            }}
          </p>
          <p
            v-if="
              (customer && (customer.city || customer.address)) ||
              (employee && (employee.city || employee.address))
            "
            class="label"
          >
            {{
              (customer !== undefined && customer.city) || customer.address
                ? customer.city || customer.address
                : (employee !== undefined && employee.city) || employee.address
                ? employee.city || employee.address
                : ""
            }}
          </p>
          <p
            v-if="(customer && customer.id) || (employee && employee.id)"
            class="profile-link"
            @click="moveToProfile"
          >
            Przejdź do profilu
          </p>
        </div>
        <div class="p-0">
          <p class="label">Przypisana osoba:</p>
          <custom-select
            :isMultiple="true"
            :options="
              ((adminsList && adminsList.data) || []).map((e) => ({
                value: e.phone,
                name: e.phone,
                shortName: e.phone,
              }))
            "
            :graySelect="true"
            :isAutocomplete="true"
            :large="true"
            :markSelected="true"
            style="width: 320px"
            :smallOptions="true"
            :prePick="adminAssignedToTask"
            @newPick="(e) => (adminAssignedToTask = e)"
            :class="
              fieldsErrors && fieldsErrors.includes('adminAssignedToTask')
                ? 'error-content'
                : ''
            "
          />
        </div>
        <div class="p-0">
          <dod-custom-textarea
            title="Opis:"
            placeholder="Opis zadania"
            :prePick="description"
            :rowsNumber="5"
            @change="(e) => (description = e)"
          />
        </div>
        <div class="p-0">
          <DodCustomDateInput
            title="Termin wykonania"
            placeholder=""
            :prePick="deadline"
            @dateChange="(e) => (deadline = e)"
          />
        </div>
        <custom-button
          style="margin-left: auto; width: 100%"
          :title="task && task.id ? 'Zapisz' : 'Dodaj'"
          gradient="true"
          custom-styles="border-radius: 50px"
          @click="onSubmit"
        />
      </div>
      <div v-if="task && task.id" class="messages" id="messages-wrapper">
        <DodChatMessage
          v-for="message in task.messages"
          :key="message.id"
          :message="message"
          @messageDeleted="(id) => $emit('messageDeleted', id)"
          @editMessage="(data) => $emit('messageEdited', data)"
        />
        <dod-custom-textarea
          placeholder="Twoja wiadomość..."
          :rowsNumber="5"
          style="margin-top: auto"
          :handleEnterAction="handleSendMessage"
          @change="(e) => (message = e)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomSelect from "../CustomSelect.vue";
import DodCustomDateInput from "./DodCustomDateInput.vue";
import DodCustomTextarea from "./DodCustomTextarea.vue";
import DodChatMessage from "./DodChatMessage.vue";
import CustomButton from "../CustomButton.vue";
export default {
  components: {
    CustomSelect,
    DodCustomDateInput,
    DodCustomTextarea,
    DodChatMessage,
    CustomButton,
  },
  props: ["task", "customerUser", "employeeUser"],
  emits: ["updateTask", "newTask", "messageSend", "messageDeleted", "messageEdited"],
  data() {
    return {
      newTitle: "",
      newCategoryId: "",
      newPriorityId: "",
      customer: "",
      employee: "",
      adminAssignedToTask: [],
      description: "",
      deadline: "",
      message: "",
      customKey: new Date().getTime(),
      fieldsErrors: [],
    };
  },
  async mounted() {
    await this.$store.dispatch("getDodUsers", {
      search: "",
    });
    if (this.employeeUser) {
      const userToSet = (this.usersList && this.usersList.data || []).find(
        (user) => user.id === this.employeeUser.id
      );
      this.handleNewPersonPick(userToSet);
    }
    if (this.customerUser) {
      const userToSet = (this.usersList && this.usersList.data || []).find(
        (user) => user.id === this.customerUser.id
      );
      this.handleNewPersonPick(userToSet);
    }
  },
  computed: {
    tasksCategories() {
      return this.$store.getters.getDodTasksCategories;
    },
    tasksPriorities() {
      return this.$store.getters.getDodTasksPriorities;
    },
    usersList() {
      return this.$store.getters.getDodUsersList;
    },
    adminsList() {
      return this.$store.getters.getDodAdminsList;
    },
  },
  methods: {
    moveToProfile() {
      const routeObject =
        this.customer && this.customer.id
          ? { name: "DodCustomerDetails", params: { id: this.customer.id } }
          : this.employee && this.employee.id
          ? { name: "DodEmployeeDetails", params: { id: this.employee.id } }
          : {};
      if (routeObject && routeObject.name) {
        document.getElementById("dodAddOrEditTask-close").click();
        this.$router.push(routeObject);
      }
    },
    handleSendMessage(message) {
      if (message) {
        this.$emit("messageSend", {
          text: message.replace("\n", ""),
          admins: this.adminAssignedToTask,
          customerId: this.customer && this.customer.id ? this.customer.id : "",
          employeeId: this.employee && this.employee.id ? this.employee.id : "",
        });
      } else {
        this.$notify({
          group: "error",
          text: "Wiadomość nie może być pusta",
        });
      }
    },
    handleNewPersonPick(personObj) {
      if (personObj && personObj.role === "CUSTOMER") {
        this.customer = personObj;
        this.employee = "";
      } else if (personObj && personObj.role === "EMPLOYEE") {
        this.employee = personObj;
        this.customer = "";
      }
    },
    onSubmit() {
      this.fieldsErrors = [];

      if (!this.newTitle) {
        this.fieldsErrors.push("newTitle");
      }
      if (!this.newCategoryId) {
        this.fieldsErrors.push("newCategoryId");
      }
      if (!this.newPriorityId) {
        this.fieldsErrors.push("newPriorityId");
      }
      if (!this.adminAssignedToTask || this.adminAssignedToTask.length === 0) {
        this.fieldsErrors.push("adminAssignedToTask");
      }
      // if (!this.employee && !this.customer) {
      //   this.fieldsErrors.push("person");
      // }
      if (this.fieldsErrors && this.fieldsErrors.length > 0) {
        this.$notify({
          group: "error",
          text: `Uzupełnij wymagane pola`,
        });
        return;
      }

      this.$emit(this.task && this.task.id ? "updateTask" : "newTask", {
        title: this.newTitle,
        categoryId: this.newCategoryId,
        priorityId: this.newPriorityId,
        admins: this.adminAssignedToTask,
        customerId:
          this.customerUser && this.customerUser.id
            ? this.customerUser.id
            : this.customer && this.customer.id
            ? this.customer.id
            : "",
        employeeId:
          this.employeeUser && this.employeeUser.id
            ? this.employeeUser.id
            : this.employee && this.employee.id
            ? this.employee.id
            : "",
        dueDate: this.deadline,
        description: this.description,
      });
    },
  },
  watch: {
    task() {
      this.newTitle = this?.task?.title || "";
      this.newCategoryId = this?.task?.category?.id || "";
      this.newPriorityId = this?.task?.priority?.id || "";
      this.adminAssignedToTask = this?.task?.admins?.map((a) => a.admin) || [];
      this.description = this?.task?.description || "";
      this.deadline = this?.task?.dueDate || "";
      this.customKey = new Date().getTime();
      this.rem;
    },

    customerUser() {
      if (this.customerUser) {
        this.customer = this.customerUser;
        const userToSet = (this.usersList && this.usersList.data || []).find(
          (user) => user.id === this.customerUser.id
        );
        this.handleNewPersonPick(userToSet);
      }
    },
    employeeUser() {
      if (this.employeeUser) {
        this.customer = this.employeeUser;
        const userToSet = (this.usersList && this.usersList.data || []).find(
          (user) => user.id === this.employeeUser.id
        );
        this.handleNewPersonPick(userToSet);
      }
    },
  },
  updated() {
    const messagesWrapperNode = document.getElementById("messages-wrapper");
    if (messagesWrapperNode) {
      setTimeout(() => {
        messagesWrapperNode.scroll({
          behavior: "smooth",
          left: 0,
          top: messagesWrapperNode.scrollHeight,
        });
      }, 500);
    }
  },
};
</script>

<style scoped>
.container {
  min-width: 500px;
  color: #090741;
}
.header {
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: space-between;
}
.content {
  display: flex;
}
.details {
  width: 60%;
}
.messages {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 40%;
  background-color: #f2f3f7;
  padding: 20px 10px 5px 10px;
  min-height: 100%;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  background: rgb(167, 167, 167);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #090741;
  border-radius: 10px;
}
.title {
  margin-left: 0.5rem;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: unset;
  outline: none;
  color: #090741;
  width: fit-content;
  width: 90%;
  min-height: 60px;
  height: fit-content;
}
.font-16-with-margin {
  font-size: 16px;
  margin-top: 15px;
  font-weight: 400;
}
.label {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 20px 0 5px 0;
  padding-left: 5px;
}
.select-text {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  min-width: 320px;
  border-radius: 4px;
  border-color: #c1c1cf;
}
.profile-link {
  display: block;
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  color: #090741;
  margin-top: 10px;
  padding-left: 5px;
}
.error-content {
  background: rgba(243, 184, 184, 0.5);
  border-radius: 3px;
}
</style>
